export default __webpack_public_path__ + "static/media/59.122671d7.jpg";